import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Row, Col, Form, Input, DatePicker, Select } from 'antd';
import moment from 'moment';
import * as Config from '../../../appConfig';

import ActionButtons from './actionButtons';

const { RangePicker } = DatePicker;

const IdCardInfo = ({
  employee: { id: employeeID, identityCard } = {},
  onIdCardInfoUpdate,
  ability,
}) => {
  const [form] = Form.useForm();
  const [isFormReadOnly, setIsFormReadOnly] = useState(
    (identityCard && identityCard.card_number) || !ability.toEditEmployee
  );

  const [expDateRequired, setExpDateRequired] = useState(false);
  const [trainingPeriodRequired, setTrainingPeriodRequired] = useState(false);
  const [pvcExpDateRequired, setPvcExpDateRequired] = useState(false);

  return (
    <Form
      layout="vertical"
      size="large"
      className={`ant-form-custom ${isFormReadOnly ? 'ant-form-readOnly' : ''}`}
      form={form}
      initialValues={{
        id: employeeID,
        card_number: identityCard && identityCard.card_number,
        card_validity_end:
          identityCard &&
          identityCard.card_validity_end &&
          moment(identityCard.card_validity_end),
        dra_number: identityCard && identityCard.dra_number,
        dra_training_period: identityCard &&
          identityCard.dra_training_start &&
          identityCard.dra_training_end && [
            moment(identityCard.dra_training_start),
            moment(identityCard.dra_training_end),
          ],
        dra_status: identityCard && identityCard.dra_status,
        pvc_number: identityCard && identityCard.pvc_number,
        pvc_validity_end:
          identityCard &&
          identityCard.pvc_validity_end &&
          moment(identityCard.pvc_validity_end),
        rac_mobility_id: identityCard && identityCard.rac_mobility_id,
        cc_mobility_id: identityCard && identityCard.cc_mobility_id,
        did_number: identityCard && identityCard.did_number,
      }}
      onFinish={(values) => {
        setIsFormReadOnly(!isFormReadOnly);
        if (
          (values.card_number && values.card_number !== '') ||
          (values.dra_number && values.dra_number !== '') ||
          (values.pvc_number && values.pvc_number !== '')
        ) {
          onIdCardInfoUpdate(values);
        }
      }}
    >
      <Row>
        <Col flex="auto" style={{ textAlign: 'right' }}>
          {ability.toEditEmployee && (
            <ActionButtons
              showEditBtn={isFormReadOnly}
              onEditClick={() => setIsFormReadOnly(!isFormReadOnly)}
              onCancelClick={() => {
                setIsFormReadOnly(!isFormReadOnly);
                form.resetFields();
              }}
            />
          )}
        </Col>
      </Row>
      <Row gutter={128}>
        <Col xs={24} md={6}>
          <Form.Item
            label="ID Card Number"
            name="card_number"
            // rules={[{ required: true, message: 'Please input Card Number!' }]}
          >
            <Input
              placeholder="ID Card Number"
              disabled={isFormReadOnly}
              maxLength="24"
              onChange={(e) => {
                if (e.target.value !== '') {
                  setExpDateRequired(true);
                } else {
                  setExpDateRequired(false);
                }
              }}
            />
          </Form.Item>
        </Col>
        <Col xs={24} md={18}>
          <Form.Item
            label="Exp. Date"
            name="card_validity_end"
            rules={[
              { required: expDateRequired, message: 'Please input Exp. Date!' },
            ]}
          >
            <DatePicker
              disabled={isFormReadOnly}
              format={Config.DATE_FORMAT_INPUT}
            />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={128}>
        <Col xs={24} md={6}>
          <Form.Item
            label="DRA Number"
            name="dra_number"
            // rules={[{ required: true, message: 'Please input DRA Number!' }]}
          >
            <Input
              placeholder="DRA Number"
              disabled={isFormReadOnly}
              maxLength="32"
              onChange={(e) => {
                if (e.target.value !== '') {
                  setTrainingPeriodRequired(true);
                } else {
                  setTrainingPeriodRequired(false);
                }
              }}
            />
          </Form.Item>
        </Col>
        <Col xs={24} md={18}>
          <Form.Item
            label="Training Period"
            name="dra_training_period"
            rules={[
              {
                required: trainingPeriodRequired,
                message: 'Please select training period!',
              },
            ]}
          >
            <RangePicker
              disabled={isFormReadOnly}
              format={Config.DATE_FORMAT_INPUT}
            />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={128}>
        <Col xs={24} md={6}>
          <Form.Item
            label="DRA Status"
            name="dra_status"
            rules={[{ message: 'Please select DRA status!' }]}
          >
            <Select placeholder="Please select" disabled={isFormReadOnly}>
              {[
                'UNTRAINED',
                'PURSING',
                'TRAINED',
                'FAIL',
                'PASS',
                'CERTIFIED',
              ].map((dra_status_option) => (
                <Select.Option
                  key={dra_status_option}
                  value={dra_status_option}
                >
                  {dra_status_option}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
        <Col xs={24} md={18}></Col>
      </Row>
      <Row gutter={128}>
        <Col xs={24} md={6}>
          <Form.Item
            label="PVC Number"
            name="pvc_number"
            // rules={[{ required: true, message: 'Please input Card Number!' }]}
          >
            <Input
              placeholder="PVC Number"
              disabled={isFormReadOnly}
              maxLength="24"
              onChange={(e) => {
                if (e.target.value !== '') {
                  setPvcExpDateRequired(true);
                } else {
                  setPvcExpDateRequired(false);
                }
              }}
            />
          </Form.Item>
        </Col>
        <Col xs={24} md={18}>
          <Form.Item
            label="PVC Exp. Date"
            name="pvc_validity_end"
            rules={[
              {
                required: pvcExpDateRequired,
                message: 'Please input PVC Exp. Date!',
              },
            ]}
          >
            <DatePicker
              disabled={isFormReadOnly}
              format={Config.DATE_FORMAT_INPUT}
            />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={128}>
        <Col xs={24} md={6}>
          <Form.Item
            label="RAC Mobility Id"
            name="rac_mobility_id"
            // rules={[{ required: true, message: 'Please input Card Number!' }]}
          >
            <Input
              placeholder="RAC Mobility Id"
              disabled={isFormReadOnly}
              maxLength="24"
            />
          </Form.Item>
        </Col>
        <Col xs={24} md={6}>
          <Form.Item
            label="CC Mobility Id"
            name="cc_mobility_id"
            // rules={[{ required: true, message: 'Please input Card Number!' }]}
          >
            <Input
              placeholder="CC Mobility Id"
              disabled={isFormReadOnly}
              maxLength="24"
            />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={128}>
        <Col xs={24} md={6}>
          <Form.Item
            label="DID Number"
            name="did_number"
            // rules={[{ required: true, message: 'Please input Card Number!' }]}
          >
            <Input
              placeholder="DID Number"
              disabled={isFormReadOnly}
              maxLength="24"
            />
          </Form.Item>
        </Col>
        <Col xs={24} md={6}></Col>
      </Row>
      <Form.Item name="id" hidden>
        <Input />
      </Form.Item>
    </Form>
  );
};

IdCardInfo.defaultProps = {};

IdCardInfo.propTypes = {
  employee: PropTypes.object.isRequired,
  onIdCardInfoUpdate: PropTypes.func.isRequired,
  ability: PropTypes.object.isRequired,
};

export default IdCardInfo;

// const IdCardInfo = ({ employee: { idCards } = [] }) => {
//   const columns = [
//     {
//       title: 'Card Number',
//       dataIndex: 'card_number',
//       key: 'card_number',
//     },
//     {
//       title: 'Exp. Date',
//       dataIndex: 'card_validity_end',
//       key: 'card_validity_end',
//       render: (text, recrod) => {
//         return moment(text).format(Config.DATE_FORMAT);
//       },
//     },
//     {
//       title: 'Status',
//       dataIndex: 'isActive',
//       key: 'isActive',
//       render: (text, record) => {
//         return text ? 'Active' : 'InActive';
//       },
//     },
//     {
//       title: 'Action',
//       dataIndex: 'action',
//       key: 'action',
//       width: 100,
//       render: (text, record) => (
//         <Space size="middle">
//           <a href="/">
//             <EditFilled style={{ fontSize: '18px' }} />
//           </a>
//           <a href="/">
//             <DeleteFilled
//               style={{ fontSize: '18px', color: 'rgb(255, 77, 79)' }}
//             />
//           </a>
//         </Space>
//       ),
//     },
//   ];

//   return (
//     <>
//       <Row style={{ marginTop: '1rem', marginBottom: '1rem' }}>
//         <Col flex="auto" style={{ textAlign: 'right' }}>
//           <Button type="primary" size="middle">
//             Add New ID Card
//           </Button>
//         </Col>
//       </Row>
//       <Row justify="center">
//         <Col xs={24} md={24}>
//           <Table
//             dataSource={idCards}
//             columns={columns}
//             pagination={false}
//             size="small"
//             rowKey="id"
//           />
//         </Col>
//       </Row>
//     </>
//   );
// };
